import { render, staticRenderFns } from "./CardDetailsTags.vue?vue&type=template&id=c0e1b680&"
import script from "./CardDetailsTags.vue?vue&type=script&lang=js&"
export * from "./CardDetailsTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports